import { copy } from "shared/assets";
import { IFieldType, IFormFields } from "shared/types";
import { getRegionalSettingsOptions } from "shared/utils";

const {
  bandSettings: { bandSettingsFormFields },
} = copy;

const { dateFormat, timeFormat } = getRegionalSettingsOptions();

export const fields: IFormFields = [
  {
    name: "timeZone",
    label: bandSettingsFormFields.timeZone.title,
    placeholder: bandSettingsFormFields.timeZone.placeholder,
    type: IFieldType.timezone,
  },
  {
    name: "dateFormat",
    label: bandSettingsFormFields.dateFormat.title,
    placeholder: bandSettingsFormFields.dateFormat.placeholder,
    type: IFieldType.select,
    options: dateFormat,
  },
  {
    name: "timeFormat",
    label: bandSettingsFormFields.timeFormat.title,
    placeholder: bandSettingsFormFields.timeFormat.placeholder,
    type: IFieldType.select,
    options: timeFormat,
  },
];
